export default __webpack_public_path__ + "static/media/scientific.97918b80.png";